import script from "./indexDefault.vue?vue&type=script&lang=ts&setup=true"
export * from "./indexDefault.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__